import { IMAGE_ASSET_CACHE_IGNORE_CSS_CLASS } from '../../../Cache';
import { IVideoStreamController } from './types';

export class MotionJpegController implements IVideoStreamController {
    #wrapperElement: HTMLDivElement;
    #streamElement?: HTMLImageElement;
    #url: string;

    constructor(wrapperElement: HTMLDivElement, url: string) {
        this.#wrapperElement = wrapperElement;
        this.#url = url;
    }

    get type(): string {
        return `MJPEG<${this.#url}>`;
    }

    canBePlayed(): Promise<boolean> {
        return Promise.resolve(true);
    }

    getReadyForDisplay(): Promise<void> {
        return Promise.resolve();
    }

    play(): Promise<void> {
        return Promise.resolve().then(() => {
            this.#addStreamElement();
        });
    }

    pause(): Promise<void> {
        return Promise.resolve().then(() => {
            this.#removeStreamElement();
        });
    }

    stop(): Promise<void> {
        return Promise.resolve().then(() => {
            this.#removeStreamElement();
        });
    }

    #addStreamElement(): void {
        if (this.#streamElement !== undefined) {
            return;
        }

        this.#streamElement = document.createElement('img');
        this.#streamElement.classList.add(IMAGE_ASSET_CACHE_IGNORE_CSS_CLASS);
        this.#streamElement.classList.add('video-stream');
        this.#streamElement.classList.add('video-stream--mjpeg');
        this.#streamElement.src = this.#url;

        this.#wrapperElement.appendChild(this.#streamElement);
    }

    #removeStreamElement(): void {
        if (this.#streamElement === undefined) {
            return;
        }

        this.#wrapperElement.removeChild(this.#streamElement);
        this.#streamElement = undefined;
    }
}
